const messages = JSON.parse('{"confirm":{"submit_entry":"ご入力内容をご確認ください。送信してよろしいですか？","logout":"ログアウトしてよろしいですか？","submit":"送信してよろしいですか？","delete":"削除してよろしいですか？"}}');
export default messages;